import { FiTrash2 } from "react-icons/fi";
import tenkenTheme from "../../configs/themes/tenkenTheme";
import { Button } from "flowbite-react";

const ButtonTableDelete = (props) => {
  const tmpProps = {
    ...props,
    theme: tenkenTheme.button,
    color: "delete",
    className: `lg:w-8 lg:h-8 w-7 h-7 flex justify-center items-center rounded-[4px] ${props.className}`,
  };
  return (
    <Button {...tmpProps}>
      <FiTrash2 className="text-white font-medium" size={20} />
    </Button>
  );
};

export default ButtonTableDelete;
